import React, { createContext, useContext } from 'react';
import { DashboardContextData } from '../types/dashboard';

const DashboardContext = createContext<DashboardContextData | null>(null);

interface DashboardProviderProps {
  value: DashboardContextData;
  children: React.ReactNode;
}

export const DashboardProvider = ({ value, children }: DashboardProviderProps) => (
  <DashboardContext.Provider value={value}>{children}</DashboardContext.Provider>
);

export const useDashboard = () => {
  const context = useContext(DashboardContext);

  if (!context) {
    throw new Error('useDashboard must be used within a DashboardProvider');
  }

  return context;
};
